import React from 'react';
import { useAuth } from '@hooks/useAuth';
import { useUserStore } from '../../../models'
import { LoaderContext } from '../../../App';
import { LoaderOverlay } from '@components';
import { VerifyModel } from '../components'
import { PhoneInput } from 'react-international-phone';
import { Eye, EyeOff } from 'react-feather';
import toast from 'react-hot-toast';
import { SERVER_URL } from '../../../constants';
import checkmark from '../../../assets/checkmark.png';
import { checkFileSize } from '../../../utils/check-file-size'

const Profile = () => {
    const [modal, setModal] = React.useState(false);
  const [passwordVisible, setPasswordVisible] = React.useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] =
    React.useState(false);
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');

  const [passwordError, setPasswordError] = React.useState(null);
  const [confirmPasswordError, setConfirmPasswordError] = React.useState(null);
  const [auth, setAuth] = React.useState(true);
  const { updateUser, updateUserImage, user, loading, verify } = useUserStore();
  // const { setLoading } = React.useContext(LoaderContext);

  const check = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setAuth(false);
      window.location.replace('/auth/signin');
    }
    return setAuth(true);
  };

  React.useEffect(() => {
    check();
    if (!auth) return window.location.replace('/auth/signin');
  }, []);

  React.useEffect(() => {
    if (!auth) window.location.replace('/auth/signin');
  }, [auth]);

  const updateImage = async (e) => {
    try {
      checkFileSize(e)
    } catch(err) {
      return
    }

    const file = e.target.files[0];

    try {
      await updateUserImage(user._id, file);

      return toast.success('Profile picture updated successfully');
    } catch (err) {
      return toast.error(err.message);
    }
  };

  const verifyUser = async ({type, front, back}) => {
    try {
      await verify(type, front, back);

      return toast.success('Verification request sent successfully');
    } catch (err) {
      toast.error(err.message);

      throw err
    }
  };

  const changePassword = async (e) => {
    e.preventDefault();

    setPasswordError(null);
    setConfirmPasswordError(null);

    let isError = false;

    // Validating password
    if (!password || password.length === 0) {
      setPasswordError('Password is required');
      isError = true;
    } else if (password.length < 8) {
      setPasswordError('Password must be at least 8 characters');
      isError = true;
    } else if (!/\d/.test(password)) {
      setPasswordError('Password must contain at least one number');
      isError = true;
    } else if (!/[a-z]/.test(password)) {
      setPasswordError('Password must contain at least one lowercase letter');
      isError = true;
    } else if (!/[A-Z]/.test(password)) {
      setPasswordError('Password must contain at least one uppercase letter');
      isError = true;
    } else if (!/[^A-Za-z0-9]/.test(password)) {
      setPasswordError('Password must contain at least one symbol');
      isError = true;
    }

    // Validating confirm password
    if (!confirmPassword || confirmPassword.length === 0) {
      setConfirmPasswordError('Confirm password is required');
      isError = true;
    } else if (confirmPassword !== password) {
      setConfirmPasswordError('Passwords do not match');
      isError = true;
    }

    if (isError) {
      return null;
    }

    try {
      await updateUser({ password, id: user._id });

      setPassword('');
      setConfirmPassword('');

      return toast.success('Password changed successfully');
    } catch (err) {
      return toast.error(err.message);
    }
  };

  const getVerificationStatus = () => {
    switch (user?.verified) {
      case 'approved':
        return (
          <p className="mt-4 m-auto px-8 py-6 border-none rounded-full text-base font-medium bg-[#77ED91] text-[#0D0D0D] text-center w-fit">
            Your account is verified
          </p>
        );
      case 'pending':
        return (
          <p className="mt-4 m-auto px-8 py-6 border-none rounded-full text-base font-medium bg-yellow-400 text-[#0D0D0D] text-center w-fit">
            Your account is pending verification
          </p>
        );
      case 'deny':
        return (
          <p className="mt-4 m-auto px-8 py-6 border-none rounded-full text-base font-medium text-white bg-red-700 text-center w-fit">
            Your account verification was denied
          </p>
        );
      default:
        return (
          <>
            <p className="text-base text-[#909093] text-center">
              To complete your verification, please attach a valid form of
              identification, such as your driver's ID or passport. Ensure the
              document is clear and legible. Your data will be securely
              processed and used only for identity confirmation.
            </p>
            <div className="flex justify-center items-center">
              <button className='!w-fit' onClick={() => setModal(true)}>
                VERIFICATION
              </button>
            </div>
          </>
        );
    }
  };

  if (loading) {
    return <LoaderOverlay />;
  }

  return (
    <div className="auth_page !pt-0">
      {modal && <VerifyModel closeModal={() => setModal(false)} verifyUser={verifyUser}/>}
      <main className="auth_container">
        <div className="auth_form !max-w-none">
          <div className="w-full md:w-[90%]">
            <div className="relative h-[200px] w-[200px] mx-auto group">
              <input
                type="file"
                id="fileInput"
                className="hidden"
                accept="image/*"
                onChange={updateImage}
              />
              <label htmlFor="fileInput" className="cursor-pointer">
                <img
                  src={
                    user?.profilePicture
                      ? `${SERVER_URL}/${user.profilePicture}`
                      : '/avatar.jpeg'
                  }
                  alt="profile picture"
                  className="h-full w-full rounded-full object-cover"
                />
              </label>

              <div className="absolute rounded-full inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <label
                  htmlFor="fileInput"
                  className="flex justify-center items-center h-full w-full text-white text-sm font-semibold px-3 py-1 rounded-lg cursor-pointer"
                >
                  <p className="px-4 py-2 border-none rounded-full text-base font-medium bg-[#77ED91] text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out hover:bg-[white] hover:scale-110 text-center">
                    Change Photo
                  </p>
                </label>
              </div>
              {user?.verified === 'approved' && (
                <img
                  src={checkmark}
                  className="absolute bottom-[-27px] right-[9px]"
                />
              )}
            </div>
            <div className="mt-10">
              <div>
                {getVerificationStatus()}
              </div>
              <div className="flex justify-between items-start w-full gap-4 mt-16 flex-col sm:flex-row">
                <div className="flex flex-col gap-6 w-full sm:w-fit">
                  <div className="auth_form_group">
                    <label htmlFor="id">ID</label>
                    <input
                      type="text"
                      id="id"
                      name="id"
                      disabled
                      onChange={() => {}}
                      value={user?._id}
                      className="disabled"
                    />
                  </div>
                  <div className="auth_form_group">
                    <label htmlFor="name">Full Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      disabled
                      onChange={() => {}}
                      value={user?.name}
                      placeholder="Enter your full name"
                      className="disabled"
                    />
                  </div>
                  <div className="auth_form_group">
                    <label htmlFor="email">Email</label>
                    <input
                      // onFocus={() => setError(null)}
                      type="email"
                      id="email"
                      name="email"
                      disabled
                      onChange={() => {}}
                      value={user?.email}
                      placeholder="Enter your email"
                      className="disabled"
                    />
                    {/* {emailError && <p className="error">{emailError}</p>} */}
                  </div>
                  <div className="auth_form_group">
                    <label htmlFor="phone">Phone</label>
                    <PhoneInput
                      id="phone"
                      name="phone"
                      disabled
                      value={user?.phone}
                      onChange={() => {}}
                      className={'items-center w-full gap-2 disabled'}
                      inputClassName="!text-white !h-auto !disabled"
                    />
                  </div>
                </div>

                <div className="flex flex-col gap-6 w-full sm:w-fit mt-10 sm:mt-0">
                  <div className="auth_form_group">
                    <label htmlFor="password">Password</label>
                    <div className="password_input">
                      <input
                        type={passwordVisible ? 'text' : 'password'}
                        autoCorrect="off"
                        autoCapitalize="none"
                        autoComplete="off"
                        autoSave="off"
                        id="password"
                        name="password"
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                        placeholder="Enter your password"
                        className={
                          passwordError ? '!border-2 !border-red-700' : ''
                        }
                      />
                      <div className="eye_container">
                        {passwordVisible ? (
                          <EyeOff
                            style={{ cursor: 'pointer' }}
                            color="rgba(119, 237, 145, .2)"
                            className="password_toggle"
                            onClick={() => setPasswordVisible(false)}
                          />
                        ) : (
                          <Eye
                            style={{ cursor: 'pointer' }}
                            color="rgba(119, 237, 145, 1)"
                            className="password_toggle"
                            onClick={() => setPasswordVisible(true)}
                          />
                        )}
                      </div>
                    </div>
                    {passwordError && <p className="error">{passwordError}</p>}
                  </div>
                  <div className="auth_form_group">
                    <label htmlFor="confirm_password">Confirm password</label>
                    <div className="password_input">
                      <input
                        type={confirmPasswordVisible ? 'text' : 'password'}
                        autoCorrect="off"
                        autoCapitalize="none"
                        autoComplete="off"
                        autoSave="off"
                        id="confirm_password"
                        name="confirm_password"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        value={confirmPassword}
                        placeholder="Confirm your password"
                        className={
                          confirmPasswordError
                            ? '!border-2 !border-red-700'
                            : ''
                        }
                      />
                      <div className="eye_container">
                        {confirmPasswordVisible ? (
                          <EyeOff
                            style={{ cursor: 'pointer' }}
                            color="rgba(119, 237, 145, .2)"
                            className="password_toggle"
                            onClick={() => setConfirmPasswordVisible(false)}
                          />
                        ) : (
                          <Eye
                            style={{ cursor: 'pointer' }}
                            color="rgba(119, 237, 145, 1)"
                            className="password_toggle"
                            onClick={() => setConfirmPasswordVisible(true)}
                          />
                        )}
                      </div>
                    </div>
                    {confirmPasswordError && (
                      <p className="error">{confirmPasswordError}</p>
                    )}
                  </div>
                  <button className="!w-full" onClick={changePassword}>
                    Change password
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Profile;
